import React, { useMemo, useState } from 'react';
import { Menu } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import ProgrammesPickerMenuPage from './programmes_picker_menu_page';
import { useGetProgrammesQuery } from '../../app/smorgAppSyncGraphQLApi';
import { programmesComparer } from '../../services/programmes';

const ProgrammesPicker = ({ selectedProgrammeId }) => {
  const { data: ownedProgrammesUnsorted } = useGetProgrammesQuery(undefined);

  const ownedProgrammes = useMemo(() => {
    if (!ownedProgrammesUnsorted) {
      return [];
    }
    const ownedProgrammesSorted = [...ownedProgrammesUnsorted];
    ownedProgrammesSorted.sort(programmesComparer);
    return ownedProgrammesSorted;
  }, [ownedProgrammesUnsorted]);

  const selectedProgrammeTitle = ownedProgrammes.find(
    (p) => p.id === selectedProgrammeId,
  )?.title;
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);

  const open = !!anchorEl;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSelectProgramme = (programmeId) => {
    handleClose();
    // tracker(userProfile, ['Switch to recipes board']);
    navigate(`/programmes/${programmeId}`);
  };

  return (
    <>
      <div style={{ cursor: 'pointer' }}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <span onClick={(ev) => setAnchorEl(ev.target)}>
          {selectedProgrammeTitle || ''}
          <FontAwesomeIcon icon="chevron-down" />
        </span>
      </div>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: { minWidth: '220px' },
        }}>
        <ProgrammesPickerMenuPage
          programmes={ownedProgrammes}
          onSelectProgramme={onSelectProgramme}
          // onCreateNewBoard={() => setShowNewBoardPage(true)}
          handleClose={handleClose}
        />
      </Menu>
    </>
  );
};

ProgrammesPicker.propTypes = {
  selectedProgrammeId: PropTypes.string.isRequired,
};

export default ProgrammesPicker;
